export { type Database } from "./databaseTypes";

import { createClient } from "@supabase/supabase-js";
import { Database } from "./databaseTypes";
import { ENVIRONMENTS } from "@fd/common/environment";
import { determineEnv } from "@fd/common/api/determineEnv";

const supabaseUrl = ENVIRONMENTS[determineEnv()].supabaseUrl;
const supabaseKey = ENVIRONMENTS[determineEnv()].supabaseAnonKey;

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);
